import React from 'react';
import AntdProForm, {
  ProFormText,
  ProFormList,
  ProFormGroup,
  ProFormSwitch,
  ProFormDateRangePicker,
  ProFormDatePicker,
} from '@ant-design/pro-form';
import { Divider } from 'antd';
import PropTypes from 'prop-types';
import ProForm from 'components/layout/ProForm';
import {
  HtmlInput,
  SelectFundingSource,
  SelectTeamMemberType,
} from 'components/input';
import RoleHierarchyList from './RoleHierarchyList';

const Form = ({ onFinish, initialValues, isEdit }) => {
  const [form] = AntdProForm.useForm();
  return (
    <ProForm
      form={form}
      onFinish={onFinish}
      requiredMark={false}
      initialValues={initialValues}
      onValuesChange={(_values) => {
        form.validateFields(['description']);
      }}
    >
      <ProFormText
        width="xxl"
        name="title"
        label="Title"
        rules={[
          { required: true, message: 'Please enter title!' },
          { whitespace: true },
        ]}
      />
      <ProFormText
        width="xl"
        name="code"
        label="Code"
        rules={[
          { required: true, message: 'Please enter code!' },
          { whitespace: true },
        ]}
      />
      <SelectFundingSource
        name="approvedFundingSource"
        label="Default Funding Source (From TDG)"
      />
      <SelectFundingSource
        name="additionalFundingSource"
        label="Default Funding Source (Matching Fund)"
      />
      <ProFormDateRangePicker
        label="Application date (YYYY-MM-DD)"
        name="date"
        width="xl"
        placeholder={['start', 'deadline']}
        rules={[
          {
            required: true,
          },
        ]}
      />
      <ProFormDatePicker
        label="Deadline for Using Allocated Funds"
        name="deadlineOfUsingUpFunding"
        width="xl"
        rules={[
          {
            required: true,
          },
        ]}
      />
      <HtmlInput
        form={form}
        name="description"
        label="Description"
        placeholder="Please Enter"
        required={true}
        requiredMessage="Please enter description"
      />
      {isEdit && (
        <ProFormSwitch
          name="active"
          label="Open for application (show in Funding applications - funding)"
        />
      )}
      <Divider />
      <ProFormList
        label="Team Members"
        name="teamMemberMapping"
        creatorButtonProps={false}
        copyIconProps={false}
        deleteIconProps={false}
        // alwaysShowItemLabel
        rules={[
          {
            required: true,
          },
        ]}
      >
        <ProFormGroup key="teamMemberMapping">
          <ProFormText
            key="name"
            label="Name"
            name="name"
            width="sm"
            fieldProps={{
              readOnly: true,
            }}
            style={{
              width: '100px',
            }}
            rules={[
              {
                required: true,
              },
            ]}
          />
          <SelectTeamMemberType
            label="Team member type"
            name="teamMemberType"
            key="teamMemberType"
            width="md"
          />
        </ProFormGroup>
      </ProFormList>
      <Divider />
      <RoleHierarchyList
        tooltip="For project leader's department is DEPARTMENT."
        name={['roleHierarchy', 'department']}
        label="Department role hierarchy"
      />
      <Divider />
      <RoleHierarchyList
        tooltip="For project leader's department is FACULTY."
        name={['roleHierarchy', 'faculty']}
        label="Faculty role hierarchy"
      />
      <Divider />
      <RoleHierarchyList
        tooltip="For project leader's department is SCHOOL."
        name={['roleHierarchy', 'school']}
        label="School role hierarchy"
      />
      <Divider />
      <RoleHierarchyList
        tooltip="For project leader's department is NAU."
        name={['roleHierarchy', 'NAU']}
        label="NAU role hierarchy"
      />
    </ProForm>
  );
};

Form.defaultProps = {
  initialValues: {
    teamMemberMapping: [
      { name: 'PL', teamMemberType: null },
      { name: 'RCPL', teamMemberType: null },
      { name: 'COPL', teamMemberType: null },
      { name: 'MEMBER', teamMemberType: null },
    ],
    roleHierarchy: {
      department: [
        {
          sequence: 0,
        },
      ],
      faculty: [
        {
          sequence: 0,
        },
      ],
      school: [
        {
          sequence: 0,
        },
      ],
      NAU: [
        {
          sequence: 0,
        },
      ],
    },
  },
  isEdit: false,
};

Form.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  isEdit: PropTypes.bool.isRequired,
};

export default Form;
